import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
//import noimage from '../../../assets/images/base-1.png'
import noimage from "../../../assets/icons/productoNoDisponible.svg";

import axios from "axios";
import * as constant from "../../../global/const";
import auth from "../../../Helpers/auth";
import { useLocation } from "react-router-dom";

export const Buscador = (props) => {
  //Globales
  const sucursal = useSelector((state) => state.page.sucursal);
  const location = useLocation();

  const url = location.pathname.split("/");
  let outSideSearch = "Todos" === url[4] ? (url.length >= 7 ? url[5] : "") : "";

  let history = props.history;
  let user = JSON.parse(auth.getUsuario());

  //Datos
  const [totalProductos, setTotalProductos] = useState(0);
  const [productos, setProductos] = useState([]);

  //Funcionales
  const [notFound, setNotFound] = useState(false);
  const { show, setShow } = props;
  const [searchGlobal, setSearchGlobal] = useState({
    searchText: outSideSearch,
  });
  const myRef = useRef();

  const handleClickOutside = (e) => {
    const aux = e.target.placeholder == "Buscar en Postobón";

    if (!aux) {
      if (!myRef.current.contains(e.target)) {
        setShow(false);
      }
    } else {
      if (e.target.value.length >= 3) {
        setShow(true);
        productos.length == 0 &&
          sucursal &&
          getProductosSimilares(e.target.value);
      }
    }
  };

  const handleChange = (text) => {
    setSearchGlobal({ searchText: text });

    if (text.length >= 3) {
      setShow(true);
      sucursal && getProductosSimilares(text);
    } else {
      if (text.length == 0) {
        setTotalProductos(0);
        setProductos([]);
        setNotFound(false);
        setShow(false);
      }
    }
  };

  //Consultas
  const getProductosSimilares = async (search) => {
    await axios
      .get(
        constant.GETPRODUCTOSBUSCADOS +
          `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&correo=${user.email}&busqueda=${search}`
      )
      .then((response) => {
        setProductos(response.data.productos);
        setTotalProductos(response.data.registros);
        if (response.data.registros == 0) {
          setNotFound(true);
        } else {
          setNotFound(false);
        }
      })
      .catch((err) => {
        console.log("Error -> ", err);
      });
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    outSideSearch = "Todos" === url[4] ? (url.length >= 7 ? url[5] : "") : "";
    setSearchGlobal({ searchText: outSideSearch });
  }, [outSideSearch]);

  return (
    <div className="align search_Cont">
      <input
        type="text"
        className="search"
        placeholder="Buscar en Postobón"
        value={searchGlobal.searchText}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (e.target.value.length >= 3) {
              setShow(false);
              let categoria = "Categoria";
              history.push(
                "/Catalogo/" +
                  categoria +
                  "/-1/" +
                  "Todos/" +
                  searchGlobal.searchText +
                  "/1"
              );
            }
          }
        }}
        onChange={(e) => {
          e.preventDefault();
          handleChange(e.target.value);
        }}
      />
      <div
        className={"buscador " + (show ? "show responsive" : "hide")}
        ref={myRef}
      >
        {
          <div className="buscador-header">
            <input
              type="text"
              className="search"
              placeholder="Buscar en Postobón"
              // style={{ backgroundImage: {iconSearchLight} }}
              // onClick={ setSearchGlobal({ searchText: ""}) }
              value={searchGlobal.searchText}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (e.target.value.length >= 3) {
                    let categoria = "Categoria";
                    setShow(false);
                    history.push(
                      "/Catalogo/" +
                        categoria +
                        "/-1/" +
                        "Todos/" +
                        searchGlobal.searchText
                    );
                  }
                }
              }}
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.value);
              }}
            />
            <p>{totalProductos} Resultados encontrados </p>
          </div>
        }

        <div className="buscador-body scrollSlider">
          {notFound ? (
            <div className="buscador-body-item">
              <svg
                width="213"
                height="229"
                viewBox="0 0 213 229"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="13" y="5" width="196" height="168" fill="#E1EEF6" />
                <rect
                  opacity="0.15"
                  x="99"
                  y="116"
                  width="27"
                  height="27"
                  rx="5"
                  fill="#0075BB"
                />
                <circle cx="64" cy="152" r="50" fill="#E1EEF6" />
                <path
                  d="M63.6117 202.007C92.8846 202.007 116.615 178.329 116.615 149.121C116.615 119.912 92.8846 96.2344 63.6117 96.2344C34.3388 96.2344 10.6084 119.912 10.6084 149.121C10.6084 178.329 34.3388 202.007 63.6117 202.007Z"
                  stroke="#474747"
                  stroke-width="5"
                  stroke-miterlimit="10"
                />
                <path
                  d="M16.2373 0C11.4655 0 7.59473 3.86218 7.59473 8.62344V146.946C7.59473 152.747 8.46673 158.335 10.0702 163.613C12.5119 162.782 4.63157 148.202 12 155C10.6387 150.447 13.341 131.93 13.341 126.942C13.341 99.2248 13.341 36.6653 13.341 36.6653H208.244V168.509C208.244 170.515 206.612 172.144 204.601 172.144L160.092 173.144H113.583C116.707 166.033 108.423 179.458 109.426 177.878H204.566C209.221 177.878 212.995 174.112 212.995 169.467V8.17873C212.995 3.66399 209.328 0 204.798 0H16.2373ZM208.244 30.9361H13.3459V8.91948C13.3459 7.15999 14.775 5.73403 16.5384 5.73403H204.698C206.655 5.73403 208.244 7.3195 208.244 9.27234V28.9361V30.9361Z"
                  fill="#474747"
                />
                <path
                  d="M30.1558 193L3 225.666"
                  stroke="#474747"
                  stroke-width="6"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <rect
                  opacity="0.15"
                  x="36"
                  y="53"
                  width="27"
                  height="27"
                  rx="5"
                  fill="#0075BB"
                />
                <rect
                  opacity="0.15"
                  x="99"
                  y="53"
                  width="27"
                  height="27"
                  rx="5"
                  fill="#0075BB"
                />
                <rect
                  opacity="0.15"
                  x="160"
                  y="53"
                  width="27"
                  height="27"
                  rx="5"
                  fill="#0075BB"
                />
                <rect
                  opacity="0.15"
                  x="160"
                  y="116"
                  width="27"
                  height="27"
                  rx="5"
                  fill="#0075BB"
                />
                <path
                  d="M77.9356 124.372L64.0092 138.253L50.6745 124.875C43.1479 117.33 30.79 128.446 38.3733 136.052L52.2511 149.982L38.8759 163.32C31.3371 170.848 42.4507 183.209 50.0544 175.628L63.9889 161.739L77.3236 175.117C84.8502 182.67 97.2081 171.554 89.6288 163.948L75.7186 150.059L89.0938 136.652C96.6488 129.152 85.5595 116.791 77.9356 124.372Z"
                  fill="#E9878A"
                />
                <path
                  d="M68 156.926C67.5804 156.332 66.9887 155.842 66.2832 155.504C65.5776 155.166 64.7824 154.993 63.9756 155C63.1688 155.008 62.378 155.196 61.6811 155.547C60.9841 155.897 60.4048 156.398 60 157"
                  stroke="#474747"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M44.4761 179.25L44.4761 179.25H44.4818C46.4845 179.25 48.5517 178.479 50.4244 176.626L50.425 176.626L63.4818 163.623L75.9337 176.115L75.9343 176.116C78.3884 178.563 81.5389 179.454 84.7893 178.588L84.7893 178.588C88.2062 177.676 91.0932 174.892 91.9682 171.635C92.7479 168.739 91.8954 165.869 89.594 163.558L89.5936 163.558L76.5885 150.559L89.0795 138.039C93.4132 133.745 92.1835 127.876 88.8805 124.551C87.3937 123.053 85.3675 121.966 83.1782 121.779C80.9809 121.591 78.6396 122.311 76.5442 124.393L76.5439 124.393L63.5111 137.388L51.0593 124.891L51.0588 124.891C46.7468 120.59 40.8645 121.806 37.5401 125.123C36.0391 126.615 34.9565 128.641 34.7765 130.827C34.5957 133.021 35.3263 135.355 37.4151 137.441C37.4153 137.441 37.4154 137.441 37.4155 137.441L50.3845 150.483L37.8929 162.94L37.8923 162.94C33.5935 167.253 34.8043 173.133 38.1234 176.463C39.7911 178.193 42.0741 179.195 44.4761 179.25ZM39.0241 126.613L39.0241 126.613L39.0263 126.611C40.4905 125.11 42.4843 124.245 44.5794 124.199C45.5136 124.209 46.4361 124.407 47.2923 124.781C48.1496 125.156 48.9228 125.699 49.5656 126.379L49.5656 126.379L49.5702 126.384L63.3295 140.189L63.506 140.366L63.683 140.189L78.0315 125.887C79.6455 124.282 81.3924 123.736 83.0211 123.873C84.6579 124.01 86.201 124.84 87.3867 126.034L87.3868 126.034C88.7254 127.381 89.6217 129.175 89.7621 131.045C89.902 132.908 89.293 134.862 87.5964 136.549L87.5957 136.55L73.7884 150.383L73.612 150.56L73.7885 150.736L88.0968 165.05C90.356 167.318 90.336 169.588 89.9295 171.091L89.9295 171.092C89.2446 173.627 86.967 175.831 84.2397 176.556C81.7442 177.218 79.3284 176.533 77.4148 174.615C77.4148 174.615 77.4147 174.615 77.4147 174.615L63.6556 160.806L63.4791 160.629L63.302 160.805L48.9452 175.116C47.3373 176.719 45.5945 177.265 43.9681 177.13C42.3338 176.994 40.7917 176.168 39.606 174.98C38.2593 173.629 37.3561 171.831 37.2113 169.954C37.0671 168.085 37.6742 166.125 39.3729 164.429L53.1841 150.664L53.3612 150.488L53.1848 150.311L38.8842 135.956C37.2842 134.35 36.7379 132.607 36.8728 130.98C37.0084 129.345 37.8344 127.801 39.0241 126.613Z"
                  fill="#474747"
                  stroke="#474747"
                  stroke-width="0.5"
                />
                <circle cx="58" cy="150" r="2" fill="#383838" />
                <circle cx="70" cy="150" r="2" fill="#383838" />
              </svg>
            </div>
          ) : (
            productos.map((p, i) => {
              const promocion = p.promocion.filter(
                (promo) => promo.tipoDescuento == 1
              );
              return (
                <div key={p.codigoSku + i} className="buscador-body-item">
                  <div className="buscador-body-item-header">
                    <img
                      src={
                        constant.URL_BASE_IMAGES +
                        "image/" +
                        p.codigoSku +
                        ".jpg"
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noimage;
                      }}
                      alt="Product image"
                    />
                  </div>
                  <div className="buscador-body-item-body">
                    <h3>{p.nombre}</h3>
                    <p>100 ml</p>
                    <span>
                      {" $" +
                        new Intl.NumberFormat("de-DE", {
                          numberingSystem: "latn",
                          style: "decimal",
                          currency: "COP",
                        })
                          .format(promocion[0] ? promocion[0].precio : p.precio)
                          .replace(",", ".")}
                    </span>
                  </div>
                  <div className="buscador-body-item-footer">
                    <button
                      onClick={() => {
                        let ruta = history.location.pathname.split("/");
                        if (ruta[1] === "detalleProducto") {
                          let res =
                            p.nombre
                              .normalize("NFD")
                              .replace(/[\u0300-\u036f]/g, "")
                              .toLowerCase()
                              .replace(/ /g, "-") +
                            "-" +
                            p.codigoSku;
                          history.push(
                            "/detalleProducto/" + res.replace("/", "-")
                          );
                          window.location.reload();
                          window.scrollTo(0, 0);
                        } else {
                          let res =
                            p.nombre
                              .normalize("NFD")
                              .replace(/[\u0300-\u036f]/g, "")
                              .toLowerCase()
                              .replace(/ /g, "-") +
                            "-" +
                            p.codigoSku;
                          history.push(
                            "/detalleProducto/" + res.replace("/", "-")
                          );
                        }
                      }}
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="buscador-footer">
          {notFound ? (
            <p>No hay productos que coincidan con tu búsqueda</p>
          ) : (
            <a
              onClick={() => {
                setShow(false);
                let categoria = "Categoria";
                history.push(
                  "/Catalogo/" +
                    categoria +
                    "/-1/" +
                    "Todos/" +
                    searchGlobal.searchText +
                    "/1"
                );
              }}
            >
              Ver todas
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
